import { Tooltip } from "@mui/material";
import React, { useEffect, useState } from "react";
import { IoMdNotifications } from "react-icons/io";
import { FormattedMessage, useIntl } from "react-intl";
import { useNavigate, useSearchParams } from "react-router-dom";
import { SortingRule } from "react-table";
import { Col, Row } from "reactstrap";
import ButtonComponent from "../../components/ButtonComponent";
import InputComponent from "../../components/InputComponent";
import Layout from "../../components/Layout/Layout";
import CancelReminderComponent from "../../components/Reminders/CancelReminderComponent";
import EditReminderComponent from '../../components/Reminders/EditReminderComponent';
import { SelectItemsProps } from "../../components/SearchSelectComponent";
import TableComponent from "../../components/TableComponent";
import Toast from "../../helpers/Toast";
import { Utilities } from "../../helpers/Utilities";
import { Parameter } from "../../models/Parameter";
import { ReminderSearchResultDTO } from "../../models/Reminder/ReminderSearchResultDTO";
import { RemindersFromMaintenancePlanResponseDTO } from "../../models/Reminders/RemindersFromMaintenancePlanResponseDTO";
import { ReminderService } from "../../services/ReminderService";
import { FcViewDetails } from "react-icons/fc";
import Routes from "../../helpers/Routes";
import SearchOrTypeSelectComponent from "../../components/SearchOrTypeSelectComponent";
import { EquipmentUtilities } from "../../EquipmentUtilities";
import { useAvailableModulesContext } from "../../context/AvailableModulesContext";
import MultiSelectComponent from "../../components/MultiSelectComponent";

export default function ReminderIndex() {

    const isConvertedToSchedulerItems: SelectItemsProps[] = [
        { value: String(true), label: "Convertido" },
        { value: String(false), label: "Por converter" }
    ];

    const intl = useIntl();
    const navigate = useNavigate();
    const reminderService = new ReminderService();
    const pageSizes: number[] = [10, 15, 30, 50];
    const [data, setData] = useState<ReminderSearchResultDTO[]>([]);
    const [loading, setLoading] = useState(false);
    const [pageCount, setPageCount] = useState(1);
    const [searchParams] = useSearchParams();
    const { reminderStatusOptions } = useAvailableModulesContext();

    const [page] = useState<number>(Utilities.LoadPageFromURLQuery("page"));
    const [pageSize] = useState<number>(Utilities.LoadPageSizeFromURLQuery(pageSizes, 15));

    //Search Parameters
    const [clientName, setClientName] = useState<string>(Utilities.LoadParameterFromURLQuery("clientName", "string", ""));
    const [equipmentSerialNumber, setEquipmentSerialNumber] = useState<string>(Utilities.LoadParameterFromURLQuery("equipmentSerialNumber", "string", ""));
    const [equipmentBrand, setEquipmentBrand] = useState<string>(Utilities.LoadParameterFromURLQuery("equipmentBrand", "string", ""));
    const [equipmentModel, setEquipmentModel] = useState<string>(Utilities.LoadParameterFromURLQuery("equipmentModel", "string", ""));
    const [initialDate, setInitialDate] = useState<string>(Utilities.LoadParameterFromURLQuery("initialDate", "string", ""));
    const [endDate, setEndDate] = useState<string>(Utilities.LoadParameterFromURLQuery("endDate", "string", ""));
    const [reminderStatus, setReminderStatus] = useState<string>(Utilities.LoadParameterFromURLQuery("reminderStatus", "string", reminderStatusOptions));
    const [selectedEquipmentBrand, setSelectedEquipmentBrand] = useState<SelectItemsProps | null>(equipmentBrand ? { label: equipmentBrand, value: equipmentBrand } : null);
    const [selectedEquipmentModel, setSelectedEquipmentModel] = useState<SelectItemsProps | null>(equipmentModel ? { label: equipmentModel, value: equipmentModel } : null);


    const [listStatus, setListStatus] = useState<SelectItemsProps[]>([]);

    const [currentPage, setCurrentPage] = useState<number>();
    const [currentPageSize, setCurrentPageSize] = useState<number>();
    const [currentSorting, setCurrentSorting] = useState<SortingRule<object>[] | null>(null);
    const [goToPage, setGoToPage] = useState<number>();
    const [initialSortBy] = useState<SortingRule<object>[]>(Utilities.LoadSortParametersFromURLQuery("sortField", "sortOrder"));
    const [reloadSearch, setReloadSearch] = useState<boolean>(false);

    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isLoadingConvertMaintenanceToAssistance, setIsLoadingConvertMaintenanceToAssistance] = useState<boolean>(false);

    // popup
    const [isEditReminderOpen, setIsEditReminderOpen] = useState<boolean>(false);
    const [currentReminder, setCurrentReminder] = useState<RemindersFromMaintenancePlanResponseDTO | null>(null);
    const [isCancelReminderOpen, setIsCancelReminderOpen] = useState<boolean>(false);

    const columns = React.useMemo(
        () => [
            {
                Header: "",
                accessor: " ",
                width: 5,
                Cell: (props: any) => {
                    const alert = props.cell.row.original.alert;
                    return (
                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                            <Tooltip
                                title="Ver Detalhes"
                                aria-label="Ver Detalhes"
                                enterNextDelay={500}
                                enterDelay={500}>
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        alignContent: "center",
                                        flexDirection: "column",
                                        cursor: "pointer"
                                    }}
                                    onClick={() => {
                                        const reminderId = props.cell.row.original.reminderId || null;
                                        ReminderDetailsNavigation(reminderId);
                                    }}
                                >
                                    <FcViewDetails className="icons" />
                                </div>
                            </Tooltip>
                            {alert != null &&
                                <Tooltip title={`Alerta: ${alert}`} aria-label={alert} enterNextDelay={500} enterDelay={500}>
                                    <div
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            cursor: "pointer",
                                            color: "red",
                                            fontSize: "24px"
                                        }}
                                    >
                                        <IoMdNotifications />
                                    </div>
                                </Tooltip>
                            }
                        </div>
                    );
                }
            },
            {
                Header: <FormattedMessage id="Screens.Reminder.Table.Client" />,
                accessor: "clientName",
                width: 20,
            },
            {
                Header: <FormattedMessage id="Screens.Reminder.Table.MaintenancePlanName" />,
                accessor: "maintenancePlanName",
                width: 20,
            },
            {
                Header: <FormattedMessage id="Screens.Reminder.Table.Date" />,
                accessor: "reminderDate",
                width: 10,
            },
            {
                Header: <FormattedMessage id="Screens.Reminder.Table.DayOfWeek" />,
                accessor: "reminderDayOfWeek",
                width: 5,
            },
            {
                Header: "Alterar Data",
                accessor: "  ",
                Cell: (props: any) => {
                    const isCancelled = props.cell.row.original.isCancelled;

                    const assistanceNumber = props.cell.row.original.assistanceNumber;
                    const isConvertedIntoAssistance = assistanceNumber !== "" && assistanceNumber !== null && assistanceNumber !== undefined;
                    return (
                        <div style={{ display: "inline-flex", height: "30px" }}>
                            <ButtonComponent
                                text={intl.formatMessage({ id: "Screens.Reminder.Table.UpdateReminderDate" })}
                                disabled={isLoading || isCancelled || isConvertedIntoAssistance}
                                onClick={() => UpdateReminderDate(props.cell.row.original)}
                            />
                        </div>
                    );
                },
                width: 5,
            },
            {
                Header: "Cancelar",
                accessor: "   ",
                Cell: (props: any) => {
                    const isCancelled = props.cell.row.original.isCancelled;
                    const reminderCurrentStatus = props.cell.row.original.reminderCurrentStatus;

                    const assistanceNumber = props.cell.row.original.assistanceNumber;
                    const isConvertedIntoAssistance = assistanceNumber !== "" && assistanceNumber !== null && assistanceNumber !== undefined;
                    return (
                        <div style={{ display: "inline-flex", height: "30px" }}>
                            {isCancelled ? (
                                <div style={{ display: "inline-flex", height: "30px", justifyContent: "center", alignItems: "center" }}>{reminderCurrentStatus}</div>
                            ) : (
                                <ButtonComponent
                                    text={intl.formatMessage({ id: "Screens.Reminder.Table.CancelReminder" })}
                                    disabled={isLoading || isConvertedIntoAssistance}
                                    onClick={() => CancelReminder(props.cell.row.original)}
                                />
                            )}
                        </div>
                    );
                },
                width: 5,
            },
            {
                Header: "Pedido",
                accessor: "    ",
                Cell: (props: any) => {
                    const assistanceNumber = props.cell.row.original.assistanceNumber;
                    const isConvertedIntoAssistance = assistanceNumber !== "" && assistanceNumber !== null && assistanceNumber !== undefined;

                    const isCancelled = props.cell.row.original.isCancelled;
                    return (
                        <>
                            {isConvertedIntoAssistance ? (
                                assistanceNumber
                            ) : (
                                <div style={{ display: "inline-flex", height: "30px" }}>
                                    <ButtonComponent
                                        text={intl.formatMessage({ id: "Screens.Reminder.Table.CreatePAT" })}
                                        disabled={isLoading || isCancelled}
                                        onClick={() => ConvertMaintenanceToAssistance(props.cell.row.original.reminderId)}
                                    />
                                </div>
                            )}
                        </>
                    );
                },
                width: 5,
            },
            {
                Header: <FormattedMessage id="Screens.Reminder.Table.ReminderFirstInterventionNumber" />,
                accessor: "reminderFirstInterventionNumber",
                width: 5,
                disableSortBy: true
            },
            {
                Header: <FormattedMessage id="Screens.Reminder.Table.ReminderFirstInterventionDate" />,
                accessor: "reminderFirstInterventionDate",
                width: 5,
                disableSortBy: true
            },
            {
                Header: <FormattedMessage id="Screens.Reminders.Filters.Status" />,
                accessor: "reminderCurrentStatus",
                width: 10,
                disableSortBy: true
            },
        ],
        []
    );

    // método navegar para detalhes lembrete
    const ReminderDetailsNavigation = async (reminderId: number | null) => {
        navigate(`${Routes.reminders.details}/${reminderId}`);
    }

    //método converter
    const ConvertMaintenanceToAssistance = async (reminderId: number | null) => {
        setIsLoadingConvertMaintenanceToAssistance(true);
        setReloadSearch(false);

        var response = await reminderService.ConvertMaintenanceToAssistance(reminderId);

        if (response.success === false) {
            Toast.Show("error", response.message);
            setIsLoadingConvertMaintenanceToAssistance(false);
            setReloadSearch(true);
            return;
        }

        Toast.Show("success", response.message);
        setIsLoadingConvertMaintenanceToAssistance(false);
        setReloadSearch(true);
    }

    const fetchData = async (
        page: number,
        pageSize: number,
        sortBy: SortingRule<object>[] | null
    ) => {
        //Atualizamos na history do browser a current page e pageSize

        var searchUrl: string = `?page=${page}&pageSize=${pageSize}` +
            // `${Utilities.AddParamToQueryIfValue("isConvertedToScheduler", "string", isConvertedToScheduler)}`;
            `${Utilities.AddParamToQueryIfValue("clientName", "string", clientName)}` +
            `${Utilities.AddParamToQueryIfValue("equipmentSerialNumber", "string", equipmentSerialNumber)}` +
            `${Utilities.AddParamToQueryIfValue("equipmentBrand", "string", equipmentBrand)}` +
            `${Utilities.AddParamToQueryIfValue("equipmentModel", "string", equipmentModel)}` +
            `${Utilities.AddParamToQueryIfValue("initialDate", "string", initialDate)}` +
            `${Utilities.AddParamToQueryIfValue("endDate", "string", endDate)}` +
            `${Utilities.AddParamToQueryIfValue("reminderStatus", "string", reminderStatus)}`;

        if (sortBy != null && sortBy.length > 0) {
            searchUrl += `${Utilities.AddParamToQueryIfValue(
                "sortField",
                "string",
                sortBy[0].id
            )}${Utilities.AddParamToQueryIfValue(
                "sortOrder",
                "string",
                sortBy[0].desc === true ? "DESC" : "ASC"
            )}`;
        }

        //Se antes não existirem parâmetros de pesquisa, significa que o user veio para aqui de uma rota, então para não ficar com duas rotas duplicadas, fazemos replace à rota

        if (searchParams.toString() === "") {
            navigate(`/reminders${searchUrl}`, { replace: true });
        } else {
            //Se já existirem parâmetros de pesquisa, não fazemos replace mas push
            navigate(`/reminders${searchUrl}`);
        }

        setLoading(true);

        var response = await reminderService.GetAll(
            mountSearchParameters(),
            Utilities.MountSortParameters(sortBy),
            page,
            pageSize
        );

        if (response.success !== true) {
            setData([]);
            setPageCount(0);
            setLoading(false);
            setCurrentPageSize(5);
            setCurrentPage(1);
            setCurrentSorting(null);
            Toast.Show("error", response.message);
            return;
        }

        //Atribuímos os dados
        setData(response.items);
        setPageCount(response.totalPages);
        setLoading(false);
        setCurrentPageSize(pageSize);
        setCurrentPage(page);
        setCurrentSorting(sortBy);
        setGoToPage(0);

        //Se a pesquisa tiver retornado múltiplas páginas e a página atual for superior ao nº de páginas que chegaram mandamos o user para a página 1
        if (response.totalPages > 0 && page > response.totalPages) {
            setGoToPage(1);
        }
    };

    //Método para montar os parâmetros de pesquisa
    const mountSearchParameters = (): Parameter[] => {
        var parameters: Parameter[] = [];

        parameters.push(new Parameter("clientName", clientName));
        parameters.push(new Parameter("equipmentSerialNumber", equipmentSerialNumber));
        parameters.push(new Parameter("equipmentBrand", equipmentBrand));
        parameters.push(new Parameter("equipmentModel", equipmentModel));
        parameters.push(new Parameter("initialDate", initialDate));
        parameters.push(new Parameter("endDate", endDate));
        parameters.push(new Parameter("reminderStatus", reminderStatus));

        return parameters;
    };

    const onEnter = () => {
        fetchData(currentPage ?? 1, currentPageSize ?? 15, currentSorting);
    };
    const onButtonClick = async () => {
        setCurrentPage(1);
        setGoToPage(1);
        fetchData(currentPage ?? 1, currentPageSize ?? 15, currentSorting);
    };
    const onRemoveFiltersClick = async () => {
        setCurrentPage(1);
        setGoToPage(1);
        setCurrentPageSize(15);

        setClientName("");
        setEquipmentSerialNumber("");
        setEquipmentBrand("");
        setEquipmentModel("");
        setInitialDate("");
        setEndDate("");
        setReminderStatus("");
        setSelectedEquipmentBrand(null);
        setSelectedEquipmentModel(null);
        setReloadSearch(true);
    };

    const getStatus = async () => {
        var response = await reminderService.GetStatus();
        if (response.success === false) {
            Toast.Show("error", response.message);
            return;
        }

        var items: SelectItemsProps[] = [];
        response.obj.forEach((element) => {
            var item: SelectItemsProps = {
                value: element.enumValue,
                label: element.name,
            };
            items.push(item);
        });

        setListStatus(items);
    };

    useEffect(() => {
        if (reloadSearch === true) {
            fetchData(currentPage ?? 1, currentPageSize ?? 15, currentSorting);
            setReloadSearch(false);
        }
    }, [reloadSearch, currentPage, pageSize]);

    useEffect(() => {
        getStatus();
    }, []);

    // Popup alterar data do lembrete
    const UpdateReminderDate = (reminder: RemindersFromMaintenancePlanResponseDTO) => {
        setCurrentReminder(reminder);
        setIsEditReminderOpen(true);
    };
    const handleEditReminder = (data: RemindersFromMaintenancePlanResponseDTO | null) => {
        setIsEditReminderOpen(false);
        setReloadSearch(true);
    };
    const handleCloseEdit = () => {
        setIsEditReminderOpen(false);
    };

    // Popup cancelar lembrete
    const CancelReminder = (reminder: RemindersFromMaintenancePlanResponseDTO) => {
        setCurrentReminder(reminder);
        setIsCancelReminderOpen(true);
    };
    const handleCancelReminder = (data: RemindersFromMaintenancePlanResponseDTO | null) => {
        setIsCancelReminderOpen(false);
        setReloadSearch(true);
    };
    const closeReminderComponent = () => {
        setIsCancelReminderOpen(false);
    };

    return (
        <>
            <Layout>
                <div className="pageContainer">
                    <div className="pageHeader">
                        <span className="pageTitle">
                            <FormattedMessage id="Screens.Reminder.Title" />
                        </span>
                    </div>

                    <div className="pageBody">
                        <Row>
                            <InputComponent
                                xl={3}
                                lg={2}
                                md={2}
                                sm={12}
                                xs={12}
                                style={{ width: "100%" }}
                                type={"text"}
                                onEnter={onEnter}
                                value={clientName}
                                label={intl.formatMessage({ id: "Screens.Reminder.SearchField.Client" })}
                                readOnly={false}
                                onChange={(t: string) => setClientName(t)}
                            />
                            <InputComponent
                                xl={1}
                                lg={2}
                                md={2}
                                sm={4}
                                xs={12}
                                style={{ width: "100%" }}
                                type={"text"}
                                onEnter={onEnter}
                                value={equipmentSerialNumber}
                                label={intl.formatMessage({ id: "Screens.Reminder.SearchField.EquipmentSerialNumber" })}
                                readOnly={false}
                                onChange={(t: string) => setEquipmentSerialNumber(t)}
                            />
                            <SearchOrTypeSelectComponent
                                xl={2}
                                lg={3}
                                md={5}
                                sm={12}
                                xs={12}
                                label={intl.formatMessage({ id: "Screens.Equipments.Search.Brand" })}
                                value={selectedEquipmentBrand}
                                loadOptions={EquipmentUtilities.SearchBrand}
                                onChange={(selected) => {
                                    setSelectedEquipmentBrand(selected);
                                    setEquipmentBrand(selected?.value || "");
                                }}
                            />
                            <SearchOrTypeSelectComponent
                                xl={2}
                                lg={3}
                                md={5}
                                sm={12}
                                xs={12}
                                label={intl.formatMessage({ id: "Screens.Equipments.Search.Model" })}
                                value={selectedEquipmentModel}
                                loadOptions={EquipmentUtilities.SearchModel}
                                onChange={(selected) => {
                                    setSelectedEquipmentModel(selected);
                                    setEquipmentModel(selected?.value || "");
                                }}
                            />
                        </Row>

                        <Row>
                            <InputComponent
                                xl={2}
                                lg={2}
                                md={2}
                                sm={4}
                                xs={12}
                                style={{ width: "100%" }}
                                type={"date"}
                                onEnter={onEnter}
                                value={initialDate}
                                label={intl.formatMessage({ id: "Screens.Reminder.SearchField.InitialDate" })}
                                readOnly={false}
                                onChange={(t: string) => setInitialDate(t)}
                            />
                            <InputComponent
                                xl={2}
                                lg={2}
                                md={2}
                                sm={4}
                                xs={12}
                                style={{ width: "100%" }}
                                type={"date"}
                                onEnter={onEnter}
                                value={endDate}
                                label={intl.formatMessage({ id: "Screens.Reminder.SearchField.EndDate" })}
                                readOnly={false}
                                onChange={(t: string) => setEndDate(t)}
                            />

                            <MultiSelectComponent
                                xl={4}
                                lg={4}
                                md={4}
                                sm={6}
                                xs={12}
                                style={{ width: "50%" }}
                                label={intl.formatMessage({ id: "Screens.Reminders.Filters.Status" })}
                                items={listStatus}
                                setSelectedString={setReminderStatus}
                                selectString={reminderStatus}
                                isDisabled={false}
                            />
                        </Row>

                        <Row>
                            <Col
                                xl={6}
                                lg={6}
                                md={6}
                                sm={12}
                                xs={12}
                                style={{ marginTop: "1em", display: "inline-flex", gap: "1rem" }}
                            >
                                <ButtonComponent
                                    text={intl.formatMessage({ id: "Common.Buttons.Search" })}
                                    onClick={onButtonClick}
                                    style={{ minWidth: "100px" }}
                                />
                                <ButtonComponent
                                    text={intl.formatMessage({ id: "Common.Buttons.RemoveFilters" })}
                                    onClick={onRemoveFiltersClick}
                                    style={{ minWidth: "113px" }}
                                />
                            </Col>
                        </Row>

                        <div className="pageComponent" style={{ width: "100%" }}>
                            <TableComponent
                                goToPage={goToPage}
                                loading={isLoading || isLoadingConvertMaintenanceToAssistance}
                                pageCount={pageCount}
                                columns={columns}
                                manualPagination={true}
                                fetchData={fetchData}
                                pageSizes={pageSizes}
                                initialPage={page}
                                initialPageSize={pageSize}
                                initialSortBy={initialSortBy}
                                data={data}
                                dontOrderFirstCollumn={false}
                            />
                        </div>

                        {isEditReminderOpen && (
                            <EditReminderComponent
                                IsOpen={isEditReminderOpen}
                                Edit={handleEditReminder}
                                CurrentReminder={currentReminder}
                                SetCurrentReminder={setCurrentReminder}
                                OnClose={handleCloseEdit}
                            />
                        )}
                        {isCancelReminderOpen && (
                            <CancelReminderComponent
                                IsOpen={isCancelReminderOpen}
                                Cancel={handleCancelReminder}
                                CurrentReminder={currentReminder}
                                SetCurrentReminder={setCurrentReminder}
                                OnClose={closeReminderComponent}
                            />
                        )}
                    </div>
                </div>
            </Layout>
        </>
    );
}
